/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import {
  ILoadingMethods,
  LoadingService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IShelfDetailMethods,
  ShelfDetailService,
  IUpdateShelfMethods,
  UpdateShelfService,
  IPrintShelfShelfMethods,
  PrintShelfService,
  IMoveToShelfMethods,
  moveToShelfService,
  IGetBoxesMethods,
  GetBoxesService
} from "./components";

export type ShelfDetailPageAgent = IStaticPageContentMethods &
  ILoadingMethods &
  IShelfDetailMethods &
  IUpdateShelfMethods &
  IPrintShelfShelfMethods &
  IGetBoxesMethods &
  IMoveToShelfMethods;

const getPlugins = () => {
  return [
    new LoadingService(),
    new StaticPageContentService(),
    new ShelfDetailService(),
    new UpdateShelfService(),
    new PrintShelfService(),
    new moveToShelfService(),
    new GetBoxesService(),
  ];
};

export const getAgent = () => {
  return createAgent<ShelfDetailPageAgent>({
    plugins: getPlugins(),
  });
};
